// ARCA-82 WS2 — Bottom-Sheet primitive (UI-SPEC §5 modal FSM).
//
// The canonical take-two action-picker flavor: a paper panel that slides up from
// the bottom with a 44×5 grab handle (Docs/UI-prototype take two .sheet). Use
// for action pickers, forms, and lists — anything where the user reaches up from
// the thumb zone. Celebratory / confirm surfaces use <Dialog> instead.
//
// Dismissal: scrim-tap + Escape (no close-x). The grab handle is the visible
// "swipe me down" affordance. All scrim/panel styling lives in pieces.css; pass
// panelStyle only for layout the recipe can't express (e.g. a scrollable body).

import type { CSSProperties, JSX, ReactNode } from 'react'

import { ModalScrim } from './ModalScrim'

export interface SheetProps {
  readonly onClose: () => void
  readonly labelledBy?: string
  readonly describedBy?: string
  readonly testId?: string
  readonly dismissOnScrimTap?: boolean
  readonly scrimClassName?: string
  readonly scrimStyle?: CSSProperties
  readonly panelClassName?: string
  readonly panelStyle?: CSSProperties
  readonly children: ReactNode
}

export function Sheet(props: SheetProps): JSX.Element {
  return <ModalScrim variant="sheet" {...props} />
}
